import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { TextValidator } from 'react-material-ui-form-validator';
import Typography from "@material-ui/core/Typography";

import useGroupSetting from "Hooks/useGroupSetting";
import { message } from "constants/message";

const useStyles = makeStyles((theme) => ({
  input: {
    marginLeft: 5,
    marginRight: 5,
  },
}));

export default function Count({
  state,
  onChangeUnit,
  onChangeThold,
  onChangeInterval,
}) {
  const groupSetting = useGroupSetting();
  const classes = useStyles();
  const messages = message();

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={2}>
          <Typography value="h6">条件</Typography>
        </Grid>
        <Grid item xs={10}>
          <Grid container>
            <Typography value="span">直近の</Typography>
            <TextValidator
              onChange={onChangeUnit}
              value={state.alert_params && state.alert_params.unit ? 
                state.alert_params.unit : 
                groupSetting.setData("unit", 60)}
              style={{ width: 185 }}
              type="number"
              InputProps={{ inputProps: { min: 5}, className: classes.input }}
              validators={['required', 'minNumber:5']}
              errorMessages={[
                messages.validation.required, 
                ((messages.validation.minNumber).replace("$1", "分")).replace("$2", "5")
              ]}
            />
            <Typography value="span">分で</Typography>
            <TextValidator
              onChange={onChangeThold}
              value={ state.alert_params && state.alert_params.thold ? 
                state.alert_params.thold : 
                groupSetting.setData("thold", 20) }
              style={{ width: 185 }}
              type="number"
              InputProps={{ inputProps: { min: 1}, className: classes.input }}
              validators={['required', 'minNumber:1']}
              errorMessages={[
                messages.validation.required, 
                ((messages.validation.minNumber).replace("$1", "件")).replace("$2", "1")
              ]}
            />
            <Typography value="span">件以上の場合に通知する</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={2}>
          <Typography value="h6">通知制限</Typography>
        </Grid>
        <Grid item xs={10}>
          <Grid container>
            <Typography value="span">前回のメール送信から</Typography>
            <TextValidator
              onChange={onChangeInterval}
              value={ state.alert_params && state.alert_params.interval ? 
                state.alert_params.interval : 
                groupSetting.setData("interval", 60) }
              style={{ width: 185 }}
              type="number"
              InputProps={{ inputProps: { min: 1}, className: classes.input }}
              validators={['required', 'minNumber:1']}
              errorMessages={[
                messages.validation.required, 
                ((messages.validation.minNumber).replace("$1", "分")).replace("$2", "1")
              ]}
            />
            <Typography value="span">
              分経過するまでメールを送信しない
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
